module.exports = __webpack_public_path__ + "img/westudy_screen_student_dash.032e3427.png";